<template>
	<el-container id="test" v-loading="test_load">
		<div class="location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
		<div class="testCon">
			<div class="test_tit">
				<h1 class="titCon">{{test_tit}}</h1>
				<div class="count">
					<!-- <p class="time">本次考试限时{{test_time}}分钟，共{{test_exam}}道题，满分为{{test_fen}}分</p> -->
                    <p style="color:#000">本次考试您的分数是：<span style="color:red;font-size: 22px;font-weight: 700;">{{fenshu}}</span> </p>
				</div>
			</div>
			<el-form :model="testForm">
				<!-- {{formal}} -->
				<div v-for="(item,key,index) in formal" :key="index">
					<div class="big_question" v-if="key!='universal'">
						<!-- {{formal}}
						{{key}} -->
						<div class="big_qs_tit">
							<font class="qiZh">{{$selfjs.qiZh(index+1)}}、</font>
							<font class="headline">{{item.headline==''?timuleixing[key]:item.headline}}</font>
							<!-- <font class="big_qs_count">（共{{item.list.length}}题）</font> -->
						</div>
						<ul :class="key" v-if="key=='single'">
							<li :class="key+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
								<p><font>{{(ti_index+1)}}.</font><span class="sp" v-html="tiObj.title.replace(/\n/g, '<br>')"></span>（{{tiObj.score}}分）</p>
								<img v-if="tiObj.question_img!=''" :src="global.oss_link+tiObj.question_img" alt="">
								<dl class="pr">
                    	            <div class="mask"></div>
									<el-form-item v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index">
										<el-radio-group v-model="tiObj.staff_answer" >
											<el-radio :label="chObj.flag">{{chObj.flag+'. '+chObj.content}}</el-radio>
										</el-radio-group>
									</el-form-item>
								</dl>
								<!-- <div><span>考生图片</span><img :src="img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div> -->
								<div v-if="tiObj.exam_img.length!=0"><span class="zhengque">考生图片</span><img :src="global.oss_link+img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div>
                    	        <!-- <p><span class="zhengque">正确答案</span></p> -->
                    	        <div class="daan"><span class="zhengque">正确答案</span>{{tiObj.correct_answer}}</div>
								<!-- <img :src="tiObj.anwser_img" alt=""> -->
								<img v-if="tiObj.anwser_img!=''" :src="global.oss_link+tiObj.anwser_img" alt="">
								<div class="daan" v-if="tiObj.analysis!=''"><span class="zhengque">答案解析</span>{{tiObj.analysis}}</div>
                    	        <div class="defen"><span class="defenspan">得分</span>{{tiObj.user_score}}</div>
								<div class="daan" v-if="tiObj.opinion!=''"><span class="zhengque">批改意见</span>{{tiObj.opinion}}</div>
							</li>
						</ul>
						<ul :class="key" v-if="key=='multiple'">
							<li :class="key+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
								<p><font>{{(ti_index+1)}}.</font><span class="sp"  v-html="tiObj.title.replace(/\n/g, '<br>')"></span>（{{tiObj.score}}分）</p>
								<!-- <img :src="tiObj.question_img" alt=""> -->
								<img v-if="tiObj.question_img!=''" :src="global.oss_link+tiObj.question_img" alt="">
								<dl class="pr">
                    	            <div class="mask"></div>
									<el-form-item>
										<el-checkbox-group v-model="tiObj.value">
											<el-checkbox v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index" :label="chObj.flag" :name="key+ti_index+ch_index">{{chObj.flag+'. '+chObj.content}}</el-checkbox>
										</el-checkbox-group>
									</el-form-item>
								</dl>
                    	        <!-- <p><span class="zhengque">正确答案</span></p> -->
								<!-- <div><span>考生图片</span><img :src="img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div> -->
								<div v-if="tiObj.exam_img.length!=0"><span class="zhengque">考生图片</span><img :src="global.oss_link+img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div>
                    	        <div class="daan"><span class="zhengque">正确答案</span>{{tiObj.correct_answer.replace(/\|\|/g,"、")}}</div>
								<img v-if="tiObj.anwser_img!=''" :src="global.oss_link+tiObj.anwser_img" alt="">
								<div class="daan" v-if="tiObj.analysis!=''"><span class="zhengque">答案解析</span>{{tiObj.analysis}}</div>
                    	        <div class="defen"><span class="defenspan">得分</span>{{tiObj.user_score}}</div>
								<div class="daan" v-if="tiObj.opinion!=''"><span class="zhengque">批改意见</span>{{tiObj.opinion}}</div>
							</li>
						</ul>
						<ul :class="key" v-if="key=='judgement'">
							<li :class="key+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
								<p><font>{{(ti_index+1)}}.</font><span class="sp"  v-html="tiObj.title.replace(/\n/g, '<br>')"></span>（{{tiObj.score}}分）</p>
								<!-- <img :src="tiObj.question_img" alt=""> -->
								<img v-if="tiObj.question_img!=''" :src="global.oss_link+tiObj.question_img" alt="">
								<dl class="pr">
                    	            <div class="mask"></div>
									<el-form-item>
										<el-radio-group v-model="tiObj.staff_answer">
											<el-radio label="对"></el-radio>
											<el-radio label="错"></el-radio>
										</el-radio-group>
									</el-form-item>
								</dl>
                    	        <!-- <p><span class="zhengque">正确答案</span></p> -->
								<!-- <div><span>考生图片</span><img :src="img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div> -->
								<div v-if="tiObj.exam_img.length!=0"><span class="zhengque">考生图片</span><img :src="global.oss_link+img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div>
                    	        <div class="daan"><span class="zhengque">正确答案</span>{{tiObj.correct_answer}}</div>
								<!-- <img :src="tiObj.anwser_img" alt=""> -->
								<img v-if="tiObj.anwser_img!=''" :src="global.oss_link+tiObj.anwser_img" alt="">
								<div class="daan" v-if="tiObj.analysis!=''"><span class="zhengque">答案解析</span>{{tiObj.analysis}}</div>
                    	        <div class="defen"><span class="defenspan">得分</span>{{tiObj.user_score}}</div>
								<div class="daan" v-if="tiObj.opinion!=''"><span class="zhengque">批改意见</span>{{tiObj.opinion}}</div>
							</li>
						</ul>
						<ul :class="key" v-if="key=='fill'">
							<li :class="key+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
								<p><font>{{(ti_index+1)}}.</font><span class="sp" v-html="tiObj.title.replace(/\n/g, '<br>')"></span>（{{tiObj.score}}分）</p>
								<img v-if="tiObj.question_img!=''" :src="global.oss_link+tiObj.question_img" alt="">
								<dl>
									<!-- <el-form-item v-for="(ch_index,i) in tiObj.fill_count" :key="i">
										<el-input v-model="tiObj.value[i].daan" autocomplete="off" readonly></el-input>
									</el-form-item> -->
									<!-- <el-form-item v-for="(ch_index,i) in tiObj.value" :key="i">
										<el-input v-model="ch_index.daan" autocomplete="off" readonly></el-input>
									</el-form-item> -->
									<span class="zhengque" style="margin-right: 8px;border-radius: 3px;font-size: 14px;padding: 2px 5px;background-color: rgb(109, 167, 226);color: rgb(255, 255, 255);">考生回答：</span>{{tiObj.staff_answer}}
									<!-- 考生回答：{{tiObj.staff_answer}} -->
								</dl>
								<!-- <div><span>考生图片</span><img :src="img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div> -->
								<div v-if="tiObj.exam_img.length!=0"><span class="zhengque">考生图片</span><img :src="global.oss_link+img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div>
                    	        <div class="daan"><span class="zhengque">正确答案</span>{{tiObj.correct_answer.replace(/\|\|/g,"、")}}</div>
								<!-- <img :src="tiObj.anwser_img" alt=""> -->
								<img v-if="tiObj.anwser_img!=''" :src="global.oss_link+tiObj.anwser_img" alt="">
								<div class="daan" v-if="tiObj.analysis!=''"><span class="zhengque">答案解析</span>{{tiObj.analysis}}</div>
                    	        <div class="defen"><span class="defenspan">得分</span>{{tiObj.user_score}}</div>
								<div class="daan" v-if="tiObj.opinion!=''"><span class="zhengque">批改意见</span>{{tiObj.opinion}}</div>
							</li>
						</ul>
						<ul :class="key" v-if="key=='open'">
							<li :class="key+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
								<p><font>{{(ti_index+1)}}.</font><span class="sp" v-html="tiObj.title.replace(/\n/g, '<br>')"></span>（{{tiObj.score}}分）</p>
								<!-- <img :src="tiObj.question_img" alt=""> -->
								<img v-if="tiObj.question_img!=''" :src="global.oss_link+tiObj.question_img" alt="">
								<dl>
									<el-form-item v-for="ch_index in tiObj.fill_count" :key="ch_index">
										<el-input type="textarea" v-model="tiObj.staff_answer" autocomplete="off" readonly></el-input>
									</el-form-item>
								</dl>
                    	        <!-- <p><span class="zhengque">正确答案</span></p> -->
								<!-- <div><span>考生图片</span><img :src="img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div> -->
								<div v-if="tiObj.exam_img.length!=0"><span class="zhengque">考生图片</span><img :src="global.oss_link+img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div>
                    	        <!-- <div class="daan"><span class="zhengque">正确答案</span>{{tiObj.correct_answer}}</div> -->
								<!-- <img :src="tiObj.anwser_img" alt=""> -->
								<div class="daan" v-if="tiObj.anwser_img!=''">
									<span class="zhengque">答案图片</span>
									<img v-if="tiObj.anwser_img!=''" :src="global.oss_link+tiObj.anwser_img" alt="">
								</div>

								<div class="daan" v-if="tiObj.analysis!=''"><span class="zhengque">答案解析</span>{{tiObj.analysis}}</div>
                    	        <div class="defen"><span class="defenspan">得分</span>{{tiObj.user_score}}</div>
								<div class="daan" v-if="tiObj.opinion!=''"><span class="zhengque">批改意见</span>{{tiObj.opinion}}</div>
							</li>
						</ul>
						<ul :class="key" v-if="key=='other1'">
							<li :class="key+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
								<p><font>{{(ti_index+1)}}.</font><span class="sp" v-html="tiObj.title.replace(/\n/g, '<br>')"></span>（{{tiObj.score}}分）</p>
								<!-- <img :src="tiObj.question_img" alt=""> -->
								<img v-if="tiObj.question_img!=''" :src="global.oss_link+tiObj.question_img" alt="">
								<dl>
									<!-- <el-form-item v-for="(ch_index,i) in tiObj.fill_count" :key="i">
										<el-input v-model="tiObj.value[i].daan" autocomplete="off" readonly></el-input>
									</el-form-item> -->
									<!-- <el-form-item v-for="(ch_index,i) in tiObj.value" :key="i">
										<el-input v-model="ch_index.daan" autocomplete="off" readonly></el-input>
									</el-form-item> -->
									<!-- 考生回答：{{tiObj.staff_answer}} -->
									<span class="zhengque" style="margin-right: 8px;border-radius: 3px;font-size: 14px;padding: 2px 5px;background-color: rgb(109, 167, 226);color: rgb(255, 255, 255);">考生回答：</span>{{tiObj.staff_answer}}
								</dl>
								<!-- <div><span>考生图片</span><img :src="img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div> -->
								<div v-if="tiObj.exam_img.length!=0"><span class="zhengque">考生图片</span><img :src="global.oss_link+img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div>
                    	        <div class="daan"><span class="zhengque">正确答案</span>{{tiObj.correct_answer.replace(/\|\|/g,"、")}}</div>
								<div class="daan" v-if="tiObj.anwser_img!=''">
									<span class="zhengque">答案图片</span>
									<img v-if="tiObj.anwser_img!=''" :src="global.oss_link+tiObj.anwser_img" alt="">
								</div>
								<!-- <img :src="tiObj.anwser_img" alt=""> -->
								<!-- <img v-if="tiObj.anwser_img!=''" :src="global.oss_link+tiObj.anwser_img" alt=""> -->
								<div class="daan" v-if="tiObj.analysis!=''"><span class="zhengque">答案解析</span>{{tiObj.analysis}}</div>
                    	        <div class="defen"><span class="defenspan">得分</span>{{tiObj.user_score}}</div>
								<div class="daan" v-if="tiObj.opinion!=''"><span class="zhengque">批改意见</span>{{tiObj.opinion}}</div>
							</li>
						</ul>
						<ul :class="key" v-if="key=='other2'">
							<li :class="key+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
								<p><font>{{(ti_index+1)}}.</font><span class="sp" v-html="tiObj.title.replace(/\n/g, '<br>')"></span>（{{tiObj.score}}分）</p>
								<!-- <img :src="tiObj.question_img" alt=""> -->
								<img v-if="tiObj.question_img!=''" :src="global.oss_link+tiObj.question_img" alt="">
								<dl>
									<!-- <el-form-item v-for="(ch_index,i) in tiObj.fill_count" :key="i">
										<el-input v-model="tiObj.value[i].daan" autocomplete="off" readonly></el-input>
									</el-form-item> -->
									<!-- <el-form-item v-for="(ch_index,i) in tiObj.value" :key="i">
										<el-input v-model="ch_index.daan" autocomplete="off" readonly></el-input>
									</el-form-item> -->
									<!-- 考生回答：{{tiObj.staff_answer}} -->
									<span class="zhengque" style="margin-right: 8px;border-radius: 3px;font-size: 14px;padding: 2px 5px;background-color: rgb(109, 167, 226);color: rgb(255, 255, 255);">考生回答：</span>{{tiObj.staff_answer}}
								</dl>
								<div v-if="tiObj.exam_img.length!=0"><span class="zhengque">考生图片</span><img :src="global.oss_link+img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div>
                    	        <div class="daan"><span class="zhengque">正确答案</span>{{tiObj.correct_answer.replace(/\|\|/g,"、")}}</div>
								<div class="daan" v-if="tiObj.anwser_img!=''">
									<span class="zhengque">答案图片</span>
									<img v-if="tiObj.anwser_img!=''" :src="global.oss_link+tiObj.anwser_img" alt="">
								</div>
								<!-- <img :src="tiObj.anwser_img" alt=""> -->
								<!-- <img v-if="tiObj.anwser_img!=''" :src="global.oss_link+tiObj.anwser_img" alt=""> -->
								<div class="daan" v-if="tiObj.analysis!=''"><span class="zhengque">答案解析</span>{{tiObj.analysis}}</div>
                    	        <div class="defen"><span class="defenspan">得分</span>{{tiObj.user_score}}</div>
								<div class="daan" v-if="tiObj.opinion!=''"><span class="zhengque">批改意见</span>{{tiObj.opinion}}</div>
							</li>
						</ul>
					</div>
				</div>
				<div v-if="formal.universal">
					<div class="big_question" v-for="(item,index) in formal.universal.list" :key="index+'sub'">
						<div>
							<div v-html="item.title" style="padding: 25px 0;"></div>
							<div v-for="(subtopic_item,sub_i) in item.subtopic" :key="subtopic_item.id+'sub'+sub_i">
								<ul :class="subtopic_item.type" v-if="subtopic_item.type=='single'">
									<li :class="'universal'+index+sub_i">
										<p><font>{{(subtopic_item.universal_sort)}}.</font><span class="sp" v-html="subtopic_item.title.replace(/\n/g, '<br>')"></span>（{{subtopic_item.score}}分）</p>
										<p v-if="subtopic_item.question_img" class="question_img">
											<img :src="ali_oss+subtopic_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.question_img})">
										</p>
										<dl class="pr">
                	    		            <div class="mask"></div>
											<el-form-item v-for="(chObj,ch_index) in subtopic_item.choices" :key="ch_index">
												<el-radio-group v-model="subtopic_item.staff_answer" >
													<el-radio :label="chObj.flag">{{chObj.flag+'. '+chObj.content}}</el-radio>
												</el-radio-group>
											</el-form-item>
										</dl>
										<div v-if="subtopic_item.exam_img.length!=0">
											<span class="zhengque">考生图片</span>
											<img :src="ali_oss+img.exam_img" alt="" v-for="(img,imgind) in subtopic_item.exam_img" :key="imgind" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+img.exam_img})">
										</div>
                	    		        <div class="daan"><span class="zhengque">正确答案</span>{{subtopic_item.correct_answer}}</div>
										<img v-if="subtopic_item.anwser_img!=''" :src="ali_oss+subtopic_item.anwser_img" alt=""  @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.anwser_img})">
										<div class="daan" v-if="subtopic_item.analysis!=''"><span class="zhengque">答案解析</span>{{subtopic_item.analysis}}</div>
                	    		        <div class="defen"><span class="defenspan">得分</span>{{subtopic_item.user_score}}</div>
										<div class="daan" v-if="subtopic_item.opinion!=''"><span class="zhengque">批改意见</span>{{subtopic_item.opinion}}</div>
									</li>
								</ul>
								<ul :class="subtopic_item.type" v-if="subtopic_item.type=='multiple'">
									<li :class="'universal'+index+sub_i">
										<p><font>{{(subtopic_item.universal_sort)}}.</font><span class="sp"  v-html="subtopic_item.title.replace(/\n/g, '<br>')"></span>（{{subtopic_item.score}}分）</p>
										<p v-if="subtopic_item.question_img" class="question_img">
											<img :src="ali_oss+subtopic_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.question_img})">
										</p>
										<dl class="pr">
                	    		            <div class="mask"></div>
											<el-form-item>
												<el-checkbox-group v-model="subtopic_item.value">
													<el-checkbox v-for="(chObj,ch_index) in subtopic_item.choices" :key="ch_index" :label="chObj.flag" :name="subtopic_item.type+index+ch_index">{{chObj.flag+'. '+chObj.content}}</el-checkbox>
												</el-checkbox-group>
											</el-form-item>
										</dl>
                	    		        <div class="daan"><span class="zhengque">正确答案</span>{{subtopic_item.correct_answer.replace(/\|\|/g,"、")}}</div>
										<img v-if="subtopic_item.anwser_img!=''" :src="ali_oss+subtopic_item.anwser_img" alt=""  @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.anwser_img})">
										<div class="daan" v-if="subtopic_item.analysis!=''"><span class="zhengque">答案解析</span>{{subtopic_item.analysis}}</div>
                	    		        <div class="defen"><span class="defenspan">得分</span>{{subtopic_item.user_score}}</div>
										<div class="daan" v-if="subtopic_item.opinion!=''"><span class="zhengque">批改意见</span>{{subtopic_item.opinion}}</div>
									</li>
								</ul>
								<ul :class="subtopic_item.type" v-if="subtopic_item.type=='judgement'">
									<li :class="'universal'+index+sub_i">
										<p><font>{{(subtopic_item.universal_sort)}}.</font><span class="sp"  v-html="subtopic_item.title.replace(/\n/g, '<br>')"></span>（{{subtopic_item.score}}分）</p>
										<p v-if="subtopic_item.question_img" class="question_img">
											<img :src="ali_oss+subtopic_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.question_img})">
										</p>
										<dl class="pr">
                	    		            <div class="mask"></div>
											<el-form-item>
												<el-radio-group v-model="subtopic_item.staff_answer">
													<el-radio label="对"></el-radio>
													<el-radio label="错"></el-radio>
												</el-radio-group>
											</el-form-item>
										</dl>
                	    		        <div class="daan"><span class="zhengque">正确答案</span>{{subtopic_item.correct_answer}}</div>
										<img v-if="subtopic_item.anwser_img!=''" :src="ali_oss+subtopic_item.anwser_img" alt=""  @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.anwser_img})">
										<div class="daan" v-if="subtopic_item.analysis!=''"><span class="zhengque">答案解析</span>{{subtopic_item.analysis}}</div>
                	    		        <div class="defen"><span class="defenspan">得分</span>{{subtopic_item.user_score}}</div>
										<div class="daan" v-if="subtopic_item.opinion!=''"><span class="zhengque">批改意见</span>{{subtopic_item.opinion}}</div>
									</li>
								</ul>
								<ul :class="subtopic_item.type" v-if="subtopic_item.type=='fill'">
									<li :class="'universal'+index+sub_i">
										<p><font>{{(subtopic_item.universal_sort)}}.</font><span class="sp" v-html="subtopic_item.title.replace(/\n/g, '<br>')"></span>（{{subtopic_item.score}}分）</p>
										<p v-if="subtopic_item.question_img" class="question_img">
											<img :src="ali_oss+subtopic_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.question_img})">
										</p>
										<dl>
											<span class="zhengque" style="margin-right: 8px;border-radius: 3px;font-size: 14px;padding: 2px 5px;background-color: rgb(109, 167, 226);color: rgb(255, 255, 255);">考生回答</span>{{subtopic_item.staff_answer}}
										</dl>
										<div v-if="subtopic_item.exam_img.length!=0">
											<span class="zhengque">考生图片</span>
											<img :src="ali_oss+img.exam_img" alt="" v-for="(img,imgind) in subtopic_item.exam_img" :key="imgind" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+img.exam_img})">
										</div>
                	    		        <div class="daan"><span class="zhengque">正确答案</span>{{subtopic_item.correct_answer.replace(/\|\|/g,"、")}}</div>
										<img v-if="subtopic_item.anwser_img!=''" :src="ali_oss+subtopic_item.anwser_img" alt=""  @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.anwser_img})">
										<div class="daan" v-if="subtopic_item.analysis!=''"><span class="zhengque">答案解析</span>{{subtopic_item.analysis}}</div>
                	    		        <div class="defen"><span class="defenspan">得分</span>{{subtopic_item.user_score}}</div>
										<div class="daan" v-if="subtopic_item.opinion!=''"><span class="zhengque">批改意见</span>{{subtopic_item.opinion}}</div>
									</li>
								</ul>
								<ul :class="subtopic_item.type" v-if="subtopic_item.type=='open'">
									<li :class="'universal'+index+sub_i">
										<p><font>{{(subtopic_item.universal_sort)}}.</font><span class="sp" v-html="subtopic_item.title.replace(/\n/g, '<br>')"></span>（{{subtopic_item.score}}分）</p>
										<p v-if="subtopic_item.question_img" class="question_img">
											<img :src="ali_oss+subtopic_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.question_img})">
										</p>
										<dl>
											<el-form-item>
												<el-input type="textarea" v-model="subtopic_item.staff_answer" autocomplete="off" readonly></el-input>
											</el-form-item>
										</dl>
										<div v-if="subtopic_item.exam_img.length!=0">
											<span class="zhengque">考生图片</span>
											<img :src="ali_oss+img.exam_img" alt="" v-for="(img,imgind) in subtopic_item.exam_img" :key="imgind" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+img.exam_img})">
										</div>
										<div class="daan" v-if="subtopic_item.anwser_img!=''">
											<span class="zhengque">答案图片</span>
											<img v-if="subtopic_item.anwser_img!=''" :src="ali_oss+subtopic_item.anwser_img" alt="" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+subtopic_item.anwser_img})">
										</div>
										<div class="daan" v-if="subtopic_item.analysis!=''"><span class="zhengque">答案解析</span>{{subtopic_item.analysis}}</div>
                	    		        <div class="defen"><span class="defenspan">得分</span>{{subtopic_item.user_score}}</div>
										<div class="daan" v-if="subtopic_item.opinion!=''"><span class="zhengque">批改意见</span>{{subtopic_item.opinion}}</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</el-form>
		</div>
		<el-dialog
			class="question_preview"
			title=""
			width="intial"
			:visible.sync="question_preview_visible" center>
			<span slot="footer" class="dialog-footer"><img :src="preview_img_src"></span>
		</el-dialog>
	</el-container>
</template>

<script>
var tnum
export default {
	name: 'test'
	,data () {
		tnum=0;
		let formal={
			single:{	 //单选题
				list: [
				// 	{ //试题列表数组
				// 	id:'233',
				// 	title:'单选题A',  //题目名称
				// 	choices:[{  //选项,可能为null 例如填空题或者简答题
				// 		flag:'A',
				// 		content:'单选1_答案A'
				// 	},{
				// 		flag:'B',
				// 		content:'单选1_答案B'
				// 	}],
				// 	fill_count:2, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// },{
				// 	id:'233',
				// 	title:'单选题B',  //题目名称
				// 	choices:[{  //选项,可能为null 例如填空题或者简答题
				// 		flag:'A',
				// 		content:'单选2_答案A'
				// 	},{
				// 		flag:'B',
				// 		content:'单选2_答案B'
				// 	}],
				// 	fill_count:2, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// }
				],
			},
			multiple:{		//多选题
				list:[
				// 	{ //试题列表数组
				// 	id:'233',
				// 	title:'下列选项中，不是URL地址中所包含的信息是（     ）。',  //题目名称
				// 	choices:[{  //选项,可能为null 例如填空题或者简答题
				// 		flag:'A',
				// 		content:'早餐吃啥'
				// 	},{
				// 		flag:'B',
				// 		content:'午餐吃啥'
				// 	}],
				// 	fill_count:2, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// },{
				// 	id:'233',
				// 	title:'__利国家生死以，__因祸福避趋之',  //题目名称
				// 	choices:[{  //选项,可能为null 例如填空题或者简答题
				// 			flag:'A',
				// 			content:'早餐吃啥'
				// 	},{
				// 		flag:'B',
				// 		content:'午餐吃啥'
				// 	}],
				// 	fill_count:2, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// }
				],
			},
			judgement:{		//判断题
				list:[
				// 	{ //试题列表数组
				// 	id:'233',
				// 	title:'判断题1',  //题目名称
				// 	choices:[{  //选项,可能为null 例如填空题或者简答题
				// 		flag:'A',
				// 		content:'对'
				// 	},{
				// 		flag:'B',
				// 		content:'错'
				// 	}],
				// 	fill_count:2, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// },{
				// 	id:'233',
				// 	title:'判断题2',  //题目名称
				// 	choices:[{  //选项,可能为null 例如填空题或者简答题
				// 			flag:'A',
				// 			content:'是'
				// 	},{
				// 		flag:'B',
				// 		content:'否'
				// 	}],
				// 	fill_count:2, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// }
				],
			},
			fill:{		//填空题
				list:[
				// 	{ //试题列表数组
				// 	id:'233',
				// 	title:'填空题1',  //题目名称
				// 	choices:null,
				// 	fill_count:2, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// },{
				// 	id:'233',
				// 	title:'填空题2',  //题目名称
				// 	choices:null,
				// 	fill_count:5, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// }
				],
			},
			open:{		//主观题
				list:[
				// 	{ //试题列表数组
				// 	id:'233',
				// 	title:'主观题A',  //题目名称
				// 	choices:null,
				// 	fill_count:1, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// },{
				// 	id:'233',
				// 	title:'主观题B',  //题目名称
				// 	choices:null,
				// 	fill_count:1, //选项
				// 	score:1, //得分
				// 	staff_answer:'', //用户选项
				// }
				],
			},
			universal:{
				list:[]
			}
		}

		return {
			xieyi:window.location.protocol,
			ali_oss:this.global.oss_link,
			timuleixing:{single:'单选题',multiple:'多选',judgement:'判断题',fill:'填空题',open:'问答题',other1:'名词解释',other2:'论述分析题',},
			time_cal_show:false,
			test_load:true,
            asd:['A','B'],
			location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
			},{
				title:"我的考试",
				router:"/web/exam_list",
				name: 'exam_list',
				activeIndex: 'index',
				query:{page:'exam_list'}
			}],
			test_tit:'',
			test_time:0,
			test_fen:0,
			test_exam:0,
            fenshu:'',
			testForm:{
				single:[],
				multiple:[],
				judgement:[],
				fill:[],
				open:[],
			},
			formal:formal,
			timeCal:"0:00:00",
			universal_sort:0,
			question_preview_visible:false,
			preview_img_src:'',
		}
	}
	,mounted:function(){
		var that=this
			,token=this.$cookies.get("token")
			,serverSrc=that.global.serverSrc
			,qianzui=that.global.qianzui
			,question_info
		//获取试题信息
		let url = serverSrc + qianzui + "/exam/user_exam"
		this.$ajax.get(url,{
            params:{
                test_id:this.$route.query.test_id,
                log_id:this.$route.query.log_id
            }
		})
		.then(function(res){
			// console.log(res);
			let resData=res.data
			
			if(resData.code==0){
				question_info = resData.data
				// console.log(question_info)
				that.test_load = false
				that.test_tit = question_info.test_title
				that.test_time = question_info.exam_duration || 10
				that.timeTotal = that.test_time * 60
				that.test_fen = question_info.max_score || 10
				that.test_exam = question_info.question_count || 30
				// that.formal = question_info.question
				for (const key in question_info.question) {
					that.formal[key] = question_info.question[key]
				}
				for (const key in that.formal) {
					if (that.formal[key].list.length==0) {
						delete that.formal[key]
					}
				}
				that.fenshu = question_info.log.score
				for(var key in question_info.question){
					// console.log(that.testForm);
					// console.log(question_info.question[key]);
					let tiNnum=question_info.question[key].list.length,
						tiArr=[]
					// console.log(question_info.question[key]);
					for(let t=0;t<tiNnum;t++){
						let tiId = question_info.question[key].list[t].id,
							tianArr = []
						if(key == "fill"){
							for(let f=0;f<question_info.question[key].list[t].fill_count;f++){
								tianArr.push("")
							}
						}
						tiArr.push({"question_id":tiId, "answer":tianArr})
					}
					that.testForm[key] = tiArr
				}
                // console.log(that.formal);
				if(that.formal.multiple){
					that.formal.multiple.list.map(function(v,i,arr){
						if(v.staff_answer.length==1){
							v.value=[v.staff_answer]
						}else{
							v.value=v.staff_answer.split("、")
						}
					}) 
					
				}
				if(that.formal.fill){
					that.formal.fill.list.forEach(function(v,i,arr){
						v.value=v.staff_answer.split("||")
                	    // console.log(that.formal.fill[i].value);
                	    that.formal.fill.list[i].value.forEach(function(v2,i2,arr2){
                	        that.formal.list.fill[i].value[i2]={
                	            daan:v2
                	        }
                	    })
					}) 
				}
				if (that.formal.universal) {
					for (let i = 0; i < that.formal.universal.list.length; i++) {
						let uni_obj = that.formal.universal.list[i]
						for (let l = 0; l < uni_obj.subtopic.length; l++) {
							that.universal_sort++
							that.formal.universal.list[i].subtopic[l].universal_sort = that.universal_sort

							if(uni_obj.subtopic[l].type=='multiple'){
								if(uni_obj.subtopic[l].staff_answer.length==1){
									uni_obj.subtopic[l].value=[v.staff_answer]
								}else{
									uni_obj.subtopic[l].value=uni_obj.subtopic[l].staff_answer.split("、")
								}
							}
						}
					}
				}
                
			}else{
				that.$message.error('无考试信息');
			}
		})
	}
	,methods:{
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		//离开页面函数
		pageout(go){
            go();
		},
		handlePictureCardPreview(file) {
			// console.log(file);
			// console.log('点击了预览按钮')
			this.question_preview_visible = true
			this.preview_img_src = file.url
		},
		
	},
	computed:{
	},
	beforeRouteLeave(to, form, next){
		// console.log(this.timeTotal);
		clearTimeout(this.global.pageTimer['examTime'])
		if(this.timeTotal != 0){
			this.pageout(next)
		}else{
			next();
		}
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
#index{background:#f4f4f4;}
.zhengque{
	margin-top: 5px;
    margin-right: 8px;
    border-radius: 3px;
    font-size: 14px;
    padding: 2px 5px;
    background-color: rgb(109, 167, 226);
    color: rgb(255, 255, 255);
}
.daan{
    margin-top: 10px;
    font-size: 16px;
	word-wrap:break-word;
}
.defen{
    margin-top: 10px;
    font-size: 16px;
}
.defenspan{
    margin-right: 8px;
    border-radius: 3px;
    font-size: 14px;
    padding: 2px 5px;
    background-color: #76d963;
    color: rgb(255, 255, 255);
}
/* .el-radio__input.is-disabled .el-radio__inner::after{
    background-color:#409EFF
} */
 .mask{
    position:absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
 }
 .pr{
     position: relative;
	 
 }
 .sp{
	color: #333 !important; 
    margin-left: 0 !important;
 }
 img{width: 100px;margin-bottom: 5px;}
</style>


// WEBPACK FOOTER //
// src/components/course_info/jieguo.vue